import { render, staticRenderFns } from "./colorful.vue?vue&type=template&id=6e1425a6&scoped=true&"
import script from "./colorful.vue?vue&type=script&lang=js&"
export * from "./colorful.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1425a6",
  null
  
)

export default component.exports